export const handlePostLogin = async (response, navigate) => {
    const state = {
        token: response.data.accessToken,
        accounts: response.data.initData.accounts,
        user: response.data.initData.userData,
        users: response.data.initData.users,
    }
    navigate('/reports', { state: state});
}